import styled from '@emotion/styled';
import { Input, Row } from 'antd';

import addIcon from 'src/public/img/icon-add-goal.svg';
import { color, font, mediaQueries, shadow } from 'src/shared/styles/variables';

interface SurveyWrapperProps {
    wrapped?: boolean;
}

export const SurveyWrapper = styled('div')<SurveyWrapperProps>(
    ({ wrapped }) =>
        !wrapped && {
            backgroundColor: color.white,
            padding: '1.31rem 1.31rem 1.75rem',
            borderRadius: 7.2,
            marginTop: '1.75rem',
            boxShadow: shadow.lightCardShadow,
        },
);

export const SurveyHeader = styled.h2(
    {
        color: color.chathamsBlue,
        paddingBottom: '0.88rem',
        marginTop: '0.44rem',
        borderBottom: `1px solid ${color.mariner}`,
    },
    font.heavy(font.size.large),
);

interface QuestionWrapperProps {
    wrapped?: boolean;
}

export const QuestionsWrapper = styled.div<QuestionWrapperProps>(({ wrapped }) => ({
    paddingTop: wrapped ? 0 : '0.88rem',
    display: 'flex',
    flexWrap: 'wrap',
}));

export const QuestionsRow = styled(Row)({
    [mediaQueries.md]: {
        flexDirection: 'column',
    },
});

interface QuestionWrapperProps {
    noShadow?: boolean;
    noPadding?: boolean;
    halfWidth?: boolean;
}

export const QuestionWrapper = styled.div<QuestionWrapperProps>(
    ({ noShadow, noPadding, halfWidth }) => ({
        backgroundColor: color.white,
        padding: noPadding ? 0 : '1.31rem 1.31rem 1.75rem',
        borderRadius: 7.2,
        marginTop: noPadding ? '0.88rem' : '1.75rem',
        boxShadow: noShadow ? 'none' : shadow.lightCardShadow,
        width: halfWidth ? '50%' : '100%',
        '&:nth-of-type(1)': {
            marginTop: noPadding ? 0 : '1.31rem',
        },
        [mediaQueries.sm]: {
            width: '100%',
        },
    }),
);

interface QuestionHeaderProps {
    large?: boolean;
}

export const QuestionHeader = styled.h3(
    {
        color: color.chathamsBlue,
    },
    (props: QuestionHeaderProps) => font.heavy(props.large ? font.size.large : font.size.medium),
);

export const StyledInput = styled(Input)({
    marginTop: '1.31rem',
});

export const QuestionDescription = styled.p(
    {
        margin: '1.31rem 0',
        lineHeight: 1.7,
        color: color.tundora,
        marginBottom: '0.88rem',
    },
    font.book(font.size.medium),
);

export const PostSurvey = styled.div({
    marginTop: '1.75rem',
});

export const AddSurveyButton = styled.button(
    {
        width: '100%',
        textAlign: 'left',
        position: 'relative',
        marginTop: '1.31rem',
        padding: '1.31rem 3.50rem 1.14rem',
        backgroundColor: color.white,
        color: color.blueLagoon,
        boxShadow: shadow.lightCardShadow,
        border: `1px solid ${color.gallery}`,
        borderRadius: 5,
        transition: 'all 0.2s',

        '&:before': {
            content: '""',
            position: 'absolute',
            width: '1.09rem',
            height: '1.09rem',
            top: '1.44rem',
            left: '1.49rem',
            backgroundImage: `url(${addIcon})`,
            backgroundSize: 'contain',
        },
        '&:hover': {
            backgroundColor: color.polar,
        },
    },
    font.heavy(font.size.medium),
);
